"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BrandLogo = _ref => {
  var {
    href,
    onClick,
    glitchClassVariant,
    variant = 'desktop'
  } = _ref;
  var classes = (0, _styles.default)();
  var width = variant === 'desktop' ? '160px' : '90px';
  var height = variant === 'desktop' ? '50px' : '27px';
  var Wrapper = props => {
    if (onClick) {
      return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
        onClick: onClick
      }, props.children);
    } else {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: href,
        variant: 'wrapper'
      }, props.children);
    }
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    width: width,
    minHeight: height
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes[glitchClassVariant]
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: width,
    src: "https://elevator-media.imgix.net/elevator-header-logo.png?ixlib=js-2.3.1&s=38f13353a3d61a22b222363a9032f2ce",
    className: classes.imageCopy
  }), /*#__PURE__*/_react.default.createElement("img", {
    width: width,
    src: "https://elevator-media.imgix.net/elevator-header-logo-red.png?ixlib=js-2.3.1&s=e1e0214b8ebcb3adf512df2a0ecd2cf4",
    className: classes.imageCopy
  }), /*#__PURE__*/_react.default.createElement("img", {
    width: width,
    src: "https://elevator-media.imgix.net/elevator-header-logo.png?ixlib=js-2.3.1&s=38f13353a3d61a22b222363a9032f2ce",
    className: classes.imageCopy
  }))));
};
var _default = exports.default = BrandLogo;